export default __webpack_public_path__ + "static/media/FAQ_5_2.d49e4821.png";